import { render, staticRenderFns } from "./Exposure.vue?vue&type=template&id=606cda5b&scoped=true"
import script from "./Exposure.vue?vue&type=script&lang=js"
export * from "./Exposure.vue?vue&type=script&lang=js"
import style0 from "./Exposure.vue?vue&type=style&index=0&id=606cda5b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606cda5b",
  null
  
)

export default component.exports